export default "__VITE_ASSET__7d8cc61d__"